module.exports = __webpack_public_path__ + "src/img/artist/artistpage1.svg?1f566902aa2f62c98dd0981882c1103b";


//////////////////
// WEBPACK FOOTER
// ./src/img/artist/artistpage1.svg
// module id = 117
// module chunks = 0